import { tipoInputEnum, tipoInputPadraoEnum } from '../../../../components/CampoForm/enum/TipoInput.enum';
import DadosEmpresa from '../../CadastroDeProcessos/Models/dados-empresa.model';

/**
 * Modelo de objeto para Formulario do eLegalize;
 * @class FormularioElegalize
 * @namespace FormularioElegalize
 */
export default class FormularioElegalize {
  /**
   * Construção basica do objeto de novo Formulario
   * @param {Number} id - Id do formulário
   * @param {EmpresaModel} empresa - Empresa
   * @param {String} keyFormulario - Key do formulário
   * @param {String} nomeNegocio - Nome do negócio
   * @param {Boolean} aConcluir - A Concluir
   * @param {Boolean} hasAnexos - Possui anexos
   * @constructor
   */
  constructor(id = null, empresa = new DadosEmpresa(), keyFormulario = '', nomeNegocio = '', aConcluir = false, camposEmpresa = [], camposSocio = [], hasAnexos = false,) {
    this.id = id;
    this.empresa = empresa;
    this.keyFormulario = keyFormulario;
    this.nomeNegocio = nomeNegocio;
    this.aConcluir = aConcluir;
    this.camposEmpresa = camposEmpresa;
    this.camposSocio = camposSocio;
    this.hasAnexos = hasAnexos;
  }

  /**
   * Formata e trata, se necessário dados do modelo para ser inserido no body de um request
   * @returns {Object} Objeto formatado para body da requisição;
   */
  asRequestBody() {
    const empresa = this.empresa.asRequestBody();
    const camposJson = JSON.stringify([...this.camposEmpresa, ...this.camposSocio]);
    const body = {
      id: this.id,
      ...empresa, 
      keyFormulario: this.keyFormulario,
      aConcluir: this.aConcluir,
      camposPersonalizados: this.converterCamposToRequest(JSON.parse(camposJson)),
      hasAnexos: this.hasAnexos
     };
    return body;
  }

  converterCamposToRequest(campos) {
      const camposTratados = [];
      for(const campo of campos) {
        if(Array.isArray(campo.opcoes) && campo.opcoes.length > 0) {
          campo.opcoes = this.converterOpcoesToRequest(campo.opcoes);
        }
        if(!campo.blocoPadrao) {
          campo.tipoInput = tipoInputEnum.getByKey(campo.tipoInput).getId();
          camposTratados.push(campo);
          continue;
        }
        delete campo.tipoInput;
        camposTratados.push(campo);
      }
      return camposTratados;
    }
  
    converterOpcoesToRequest(opcoes) {
      const opcoesConvertidas = [];
      for(const opcao of opcoes) {
        const opcaoConvertida = {
          ordem: opcao.ordem,
          descricao: opcao.label,
          descricaoHtml: opcao.labelHtml
        }
        opcoesConvertidas.push(opcaoConvertida)
      }
      opcoesConvertidas.sort((a, b) => a.ordem - b.ordem);
      return opcoesConvertidas
    }

  /**
   * Atualiza modelo com dados válidos de um objeto com dados de
   * formulário;
   * @param {Object} formData Objeto com dados do formulário
   */
  updateDados(formData) {
    for (let propriedade in formData) {
      if (!Object.keys(formData).includes(propriedade)) {
        console.warn(`WARN: Propriedade "${propriedade}" não é valido para modelo`);
        continue;
      }
      this[propriedade] = formData[propriedade];
    }
  }

  /**
   * Limpa do objeto campos vazios antes de enviar o request para o back;
   * @param {Object} body - body do request
   */
  cleanBody(body) {
    for (const prop in body) {
      if (body[prop] === '' || body[prop] === null || (Array.isArray(body[prop]) && body[prop].length == 0)) {
        delete body[prop];
      }
    }
  }

  /**
   * Formata e trata, se necessário, dados da resposta para o modelo
   */
  asModel(response, key) {
    this.id = response.id;
    this.empresa.asModel(response);
    this.keyFormulario = key;
    this.nomeNegocio = response.nomeNegocio;
    const camposEmpresa = [];
    const camposSocio = [];
    if (Array.isArray(response.camposPersonalizados)) {
      for (const campo of response.camposPersonalizados) {
        if(campo.isCampoSocio) {
          camposSocio.push(campo);
          continue;
        }
        camposEmpresa.push(campo);
      }
    }
    this.camposEmpresa = camposEmpresa;
    this.camposSocio = camposSocio;
  }
  converterCampoToModel(campo) {
    campo.tipoInput = campo.blocoPadrao? tipoInputPadraoEnum.getById(campo.blocoPadrao).getKey() : tipoInputEnum.getById(campo.tipoInput).getKey();
    return campo;
  }
}
